import moment from 'moment';
import BaseServiceCrud from './BaseServiceCrud';
import Constants from '../utils/constants';
import UrlUtils from '../utils/UrlUtils';

export default class DelegationService extends BaseServiceCrud {
    constructor() {
        super();
        this.path = 'delegation';
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            start_date: criteria.startDate ? moment(criteria.startDate).format(Constants.DATE_GET_REQUEST_FORMAT_TIME) : undefined,
            end_date: criteria.endDate ? moment(criteria.endDate).format(Constants.DATE_GET_REQUEST_FORMAT_TIME) : undefined,
            projectName: criteria?.projectName,
            status: criteria.status?.enumValue,
            first_result: criteria.firstResult,
            max_result: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        });
    }

    acceptState(id) {
        return this.fetch(`${this.domain}/${this.path}/accept-state/${id}`, {
            method: 'PATCH',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    summaryEnter(id, summary) {
        return this.fetch(`${this.domain}/${this.path}/summary/enter/${id}`, {
            method: 'PUT',
            body: JSON.stringify(summary),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    rejectState(id, rejectReason) {
        return this.fetch(`${this.domain}/${this.path}/reject-state/${id}`, {
            method: 'PATCH',
            body: JSON.stringify({message: rejectReason}),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    update(element) {
        const ownDelegation = UrlUtils.isOnView('my-delegation');
        return this.fetch(`${this.domain}/${this.path}/${ownDelegation ? 'own/' : ''}${element.id}`, {
            method: 'PUT',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    updateMySettlement(element) {
        return this.fetch(`${this.domain}/${this.path}/own/settlement/${element.id}`, {
            method: 'PUT',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    get(id) {
        const ownDelegation = UrlUtils.isOnView('my-delegation');
        return this.fetch(`${this.domain}/${this.path}/${ownDelegation ? 'own/' : ''}${id}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getList(criteria) {
        const ownDelegation = UrlUtils.isOnView('my-delegation');
        const queryString = this.getCriteria(criteria);
        return this.fetch(`${this.domain}/${this.path}/${ownDelegation ? 'own/' : ''}list${queryString}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    getEvents(date) {
        const currentDate = moment(date).format(Constants.DATE_GET_REQUEST_FORMAT_TIME);
        return this.fetch(`${this.domain}/${this.path}/own/calendar/${currentDate}`, {
            method: 'GET',
        })
            .then((res) => {
                return Promise.resolve(res);
            })
            .catch((err) => {
                throw err;
            });
    }
}
